const carouselItems = [
  {
    title: '2024年度娱乐圈十大未解之谜',
    excerpt: '从顶流塌房到神秘隐退，这一年娱乐圈埋下了太多谜团。暗网吃瓜论坛深度梳理，带你回顾那些至今没有答案的轰动事件...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20theatrical%20stage%20with%20red%20velvet%20curtains%20slightly%20opened%2C%20mysterious%20spotlight%20on%20empty%20stage%2C%20question%20mark%20silhouettes%2C%20dramatic%20cinematic%20lighting%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20crimson%20highlights%2C%20editorial%20photography%20quality&width=1000&height=560&seq=carousel-01-mystery&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '深度起底：某资本系族背后的权力游戏',
    excerpt: '暗网吃瓜群内多位金融圈知情人士联手爆料，揭开某神秘资本系族通过复杂股权结构操控多家上市公司的惊人内幕...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20boardroom%20with%20empty%20leather%20chairs%2C%20red%20glowing%20stock%20charts%20on%20multiple%20screens%2C%20ominous%20corporate%20power%20atmosphere%2C%20dramatic%20lighting%20from%20above%2C%20thriller%20movie%20aesthetic%2C%20high%20contrast%20photography&width=1000&height=560&seq=carousel-02-capital&orientation=landscape',
    tag: '深度调查',
  },
  {
    title: '吃瓜群年度最劲爆聊天记录合集',
    excerpt: '从年初到年尾，暗网吃瓜群内流传的经典对话一次看完。有些预言如今已成现实，有些爆料至今仍在发酵...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20phone%20displaying%20multiple%20glowing%20red%20chat%20bubbles%2C%20encrypted%20messaging%20aesthetic%2C%20mysterious%20digital%20communication%2C%20cyberpunk%20interface%20design%2C%20dramatic%20screen%20glow%20on%20dark%20background%2C%20underground%20network%20vibe&width=1000&height=560&seq=carousel-03-chats&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '从素人到顶流：那些年被扒光的网红人设',
    excerpt: '暗网吃瓜论坛网友历时数月整理，详细对比了20+位头部网红的人设包装与实际面目。每一个"完美形象"背后都有不为人知的故事...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20theater%20backstage%20with%20multiple%20masks%20hanging%2C%20red%20dramatic%20lighting%2C%20identity%20and%20disguise%20concept%2C%20mysterious%20atmosphere%2C%20theatrical%20dressing%20room%20with%20mirrors%2C%20film%20noir%20aesthetic%2C%20deep%20contrast&width=1000&height=560&seq=carousel-04-mask&orientation=landscape',
    tag: '专题报道',
  },
  {
    title: '娱乐圈法律纠纷大盘点：谁在告谁？',
    excerpt: '明星互告、公司与艺人纠纷、名誉权官司...暗网吃瓜独家整理2024年娱乐圈主要法律事件，揭示官司背后的商业博弈与公关策略...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20courtroom%20with%20empty%20judge%20bench%2C%20red%20gavel%20on%20dark%20wood%2C%20dramatic%20lighting%20through%20blinds%2C%20legal%20documents%20scattered%2C%20justice%20and%20drama%20concept%2C%20film%20noir%20photography%2C%20high%20contrast%20shadows&width=1000&height=560&seq=carousel-05-law&orientation=landscape',
    tag: '法律观察',
  },
  {
    title: '暗网吃瓜年度报告：320万吃瓜群众的2024',
    excerpt: '这一年，我们共同见证了无数个大瓜的诞生与反转。暗网吃瓜数据团队从用户行为、话题趋势、地域分布等维度，为你全景呈现吃瓜江湖...',
    image: 'https://readdy.ai/api/search-image?query=Dark%20data%20visualization%20with%20glowing%20red%20and%20amber%20charts%20and%20graphs%2C%20futuristic%20dashboard%20interface%2C%20big%20data%20analytics%20concept%2C%20cyberpunk%20information%20display%2C%20dramatic%20dark%20background%2C%20modern%20tech%20aesthetic&width=1000&height=560&seq=carousel-06-report&orientation=landscape',
    tag: '年度报告',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            焦点专题
          </h2>
          <span className="text-xs text-foreground-500 mt-1">6个深度报道</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="bg-background-200 rounded-xl overflow-hidden cursor-pointer group hover:bg-background-300/70 transition-colors"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/90 via-transparent to-transparent"></div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-200 group-hover:text-primary-400 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}